import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { SsnService } from './ssn.service';
import { TextMaskModule } from 'angular2-text-mask';
import { FormsModule } from '@angular/forms';
import { SsnComponent } from './ssn/ssn.component';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    TextMaskModule
  ],
  declarations: [ SsnComponent ],
  exports: [
    SsnComponent
  ],
  providers: [ SsnService ]
})
export class SsnModuleModule { }



// WEBPACK FOOTER //
// ./src/app/utils/ssn-module/ssn-module.module.ts